import "./App.css";
import { AuthService, HttpService } from "@shared/services";
import AppRouter from "AppRouter";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import SnackbarProvider from "@shared/hooks/snackbar";
import ErrorBoundary from "@shared/components/ErrorBoundary";
import { LoadingService } from "@shared/services/LoadingService";
import {
  ConfigService,
  useConfigService,
} from "@shared/services/ConfigService";

import "@shared/services/TranslateService";
import AppConst from "@shared/entities/AppConsts";
import { RegistrationService } from "@shared/services/RegistrationService";

import ReactGA from 'react-ga4';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { CaptchaService } from "@shared/services/CaptchaService";
import { DropDownMenuService } from "@shared/services/DropDownMenuService";
function Layout() {
  const { backendConfig } = useConfigService();
  const captchaKey =
    backendConfig.config.recaptchaSiteKey || AppConst.GoogleReCaptchaKey;
  return (
    <LoadingService>
      <SnackbarProvider>
        <GoogleReCaptchaProvider reCaptchaKey={captchaKey}>
          <CaptchaService>
            <AuthService>
              <HttpService>
                <DropDownMenuService>
                  <RegistrationService>
                    <AppRouter />
                  </RegistrationService>
                </DropDownMenuService>
              </HttpService>
            </AuthService>
          </CaptchaService>
        </GoogleReCaptchaProvider>
      </SnackbarProvider>
    </LoadingService>
  );
}
function App() {

  // 追蹤目前使用者位置的範例
  const location = useLocation()
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search, });
  }, [location])
  return (
    <ErrorBoundary>
      <ConfigService>
        <Layout />
      </ConfigService>
    </ErrorBoundary>
  );
}

export default App;
